import * as React from 'react';
import useWhatsappAuthLink from './useWhatsappAuthLink';

export const WhatsappAuthLinkContext = React.createContext<
  ReturnType<typeof useWhatsappAuthLink> | undefined
>(undefined);

export const useWhatsappAuthLinkContext = () => {
  const context = React.useContext(WhatsappAuthLinkContext);
  if (!context) {
    throw new Error('Must be used within a WhatsappAuthLinkContext');
  }

  return context;
};
